// SrcVer: $Id: //trak/main/adhocs/T2023/6/CLRS25/internal/web/system/common/config/angularLoadingBarConfig.js#1 $
'use strict';
angular.module('tcApp')
.config(['cfpLoadingBarProvider', function(cfpLoadingBarProvider) {
	cfpLoadingBarProvider.includeBar = true;
	cfpLoadingBarProvider.includeSpinner = false;
	cfpLoadingBarProvider.latencyThreshold = 800;
}]);
